import { render, staticRenderFns } from "./BaseSlide.vue?vue&type=template&id=7e4028c7&scoped=true"
import script from "./BaseSlide.vue?vue&type=script&lang=js"
export * from "./BaseSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4028c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e4028c7')) {
      api.createRecord('7e4028c7', component.options)
    } else {
      api.reload('7e4028c7', component.options)
    }
    module.hot.accept("./BaseSlide.vue?vue&type=template&id=7e4028c7&scoped=true", function () {
      api.rerender('7e4028c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/BaseSlide.vue"
export default component.exports